import React from "react";

import moment from "moment";

import { fileUpload, handleEditorChange, prepareEditorContentImage } from "utils";

import { LANGUAGES, LANGUAGE_CODE } from "consts";

import { Col, DatePicker, ErrorBoundary, Form, Input, Option, Row, Select, TextArea, TextEditor, UploadImage } from "components";

export const ArticleInputs = ({
  article,
  content,
  imageSuccess,
  imageURL,
  methods,
  modules,
  setContent,
  setImageSuccess,
  setImageURL,
  setLoading,
  tags,
  reloadTags,
}) => (
  <ErrorBoundary>
    <Row>
      <Col>
        <Form.Item name="image" rules={[{ required: true }]} initialValue={article ? article.image : undefined}>
          <UploadImage
            imageSuccess={imageSuccess}
            imageUrl={imageURL}
            label="Add image"
            beforeUpload={(v) => fileUpload(v, "articles", setImageSuccess, setImageURL, setLoading)}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={24}>
        <Input name="altImageText" rules={[{ required: !!imageURL }]} label="Alt Image Text" initialValue={article?.altImageText ?? ""} />
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={12}>
        <Input name="title" label="Article title" rules={[{ required: true }]} initialValue={article ? article.title : ""} />
      </Col>
      <Col sm={12} md={4}>
        <Select
          name="language"
          label="Language"
          rules={[{ required: true }]}
          initialValue={article ? article.language : LANGUAGE_CODE.GERMAN}
          onChange={reloadTags}
        >
          {LANGUAGES.filter((language) => language.showOnAdmin).map((language, index) => (
            <Option key={index} value={language.code.toLowerCase()}>
              {language.language}
            </Option>
          ))}
        </Select>
      </Col>
      <Col sm={12} md={4}>
        <Select name="active" label="Visibility" rules={[{ required: true }]} initialValue={article ? article.active : false}>
          <Option value={true}>Enabled</Option>
          <Option value={false}>Disabled</Option>
        </Select>
      </Col>
      <Col sm={12} md={4}>
        <Select name="usersOnly" label="Access" rules={[{ required: true }]} initialValue={article ? article.usersOnly : false}>
          <Option value={true}>Users only</Option>
          <Option value={false}>Everyone</Option>
        </Select>
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={12}>
        <Select
          name="tags"
          mode="tags"
          style={{ width: "100%" }}
          label="Select tags"
          rules={[{ required: true }]}
          initialValue={
            article
              ? article.tags.reduce((a, { tag }) => {
                  a.push(tag);
                  return a;
                }, [])
              : undefined
          }
        >
          {tags.map((item, i) => (
            <Option value={item} key={i}>
              {item}
            </Option>
          ))}
        </Select>
      </Col>
      <Col sm={24} md={12}>
        <DatePicker
          initialValue={article && article.schedule ? moment(article.schedule) : null}
          name="schedule"
          label="Scheduled To"
          rules={[{ required: false }]}
          format={["DD.MM.YYYY"]}
          showNow={false}
        />
      </Col>
      <Col sm={24} md={12}>
        <Select
          name="methods"
          style={{ width: "100%" }}
          label="Select a method"
          rules={[{ required: false }]}
          initialValue={article && article.methods[0] ? article.methods[0].method : undefined}
        >
          <Option value={null}>None</Option>
          {methods.map((item, i) => (
            <Option value={item} key={i}>
              {item}
            </Option>
          ))}
        </Select>
      </Col>
      <Col sm={24} md={12}>
        <Select
          name="modules"
          style={{ width: "100%" }}
          label="Select a module"
          rules={[{ required: false }]}
          initialValue={article && article.modules[0] ? article.modules[0].module : undefined}
        >
          <Option value={null}>None</Option>
          {modules.map((item, i) => (
            <Option value={item} key={i}>
              {item}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={24}>
        <Input name="htmlTitle" label="HTML Title (max. 60)" initialValue={article?.htmlTitle ?? ""} maxLength={60} />
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={24}>
        <TextArea name="htmlDescription" label="HTML Description (max. 155)" initialValue={article?.htmlDescription ?? ""} maxLength={155} />
      </Col>
    </Row>
    <Row>
      <Col>
        <TextEditor
          init={{
            images_upload_handler: (blobInfo, success) => {
              prepareEditorContentImage({ file: blobInfo.blob(), location: "articles" }).then((res) => success(res));
            },
          }}
          initialValue={article ? article.content : ""}
          onEditorChange={(v) => handleEditorChange(v, setContent)}
          value={content}
        />
      </Col>
    </Row>
  </ErrorBoundary>
);
